import PropTypes from 'prop-types';
import { noop } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { Button, ButtonSize } from 'app/components/core/Button';
import * as styles from './SnowflakeConnectionModal.css';

export function SnowflakeUnconfiguredConnection({ isAdmin = false, onClick = noop }) {
    const { t } = useTranslation();

    return (
        <div className={styles.unconfigured}>
            <h4>{t('components:SnowflakeConnectionStatus.modal.unconfigured.title')}</h4>
            <p>
                {t(
                    `components:SnowflakeConnectionStatus.modal.unconfigured.${
                        isAdmin ? 'admin' : 'nonAdmin'
                    }`
                )}
            </p>
            {isAdmin && (
                <Button fullWidth onClick={onClick} size={ButtonSize.MEDIUM}>
                    {t('components:SnowflakeConnectionStatus.modal.unconfigured.adminButton')}
                </Button>
            )}
        </div>
    );
}

SnowflakeUnconfiguredConnection.propTypes = {
    isAdmin: PropTypes.bool,
    onClick: PropTypes.func
};
